"use strict";Object.defineProperty(exports, "__esModule", {value: true});

var _FHIGX2EEcjs = require('../__chunks/FHIGX2EE.cjs');


var _NSONUP5Ccjs = require('../__chunks/NSONUP5C.cjs');


var _FH6HQ5JNcjs = require('../__chunks/FH6HQ5JN.cjs');
require('../__chunks/XWMMMXUK.cjs');





var _PTOCUU2Dcjs = require('../__chunks/PTOCUU2D.cjs');



var _3BSDKDKDcjs = require('../__chunks/3BSDKDKD.cjs');
require('../__chunks/XMDZRF6Y.cjs');

// src/form/form-error.tsx
var _misc = require('@ariakit/core/utils/misc');
var _react = require('react');
var TagName = "div";
var useFormError = _PTOCUU2Dcjs.createHook.call(void 0, 
  function useFormError2({
    store,
    name: nameProp,
    getItem: getItemProp,
    ...props
  }) {
    const context = _FHIGX2EEcjs.useFormContext.call(void 0, );
    store = store || context;
    _misc.invariant.call(void 0, 
      store,
      process.env.NODE_ENV !== "production" && "FormError must be wrapped in a Form component."
    );
    const id = _3BSDKDKDcjs.useId.call(void 0, props.id);
    const ref = _react.useRef.call(void 0, null);
    const name = String(nameProp);
    const getItem = _react.useCallback.call(void 0, 
      (item) => {
        const nextItem = { ...item, id: id || item.id, name, type: "error" };
        if (getItemProp) {
          return getItemProp(nextItem);
        }
        return nextItem;
      },
      [id, name, getItemProp]
    );
    const children = _FH6HQ5JNcjs.useStoreState.call(void 0, store, () => {
      const error = store == null ? void 0 : store.getError(name);
      if (error == null) return;
      if (!(store == null ? void 0 : store.getFieldTouched(name))) return;
      return error;
    });
    props = {
      role: "alert",
      children,
      ...props,
      id,
      ref: _3BSDKDKDcjs.useMergeRefs.call(void 0, ref, props.ref)
    };
    props = _NSONUP5Ccjs.useCollectionItem.call(void 0, { store, ...props, getItem });
    return props;
  }
);
var FormError = _PTOCUU2Dcjs.memo.call(void 0, 
  _PTOCUU2Dcjs.forwardRef.call(void 0, function FormError2(props) {
    const htmlProps = useFormError(props);
    return _PTOCUU2Dcjs.createElement.call(void 0, TagName, htmlProps);
  })
);



exports.FormError = FormError; exports.useFormError = useFormError;
